import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from "rxjs";
import { Alert } from "src/app/shared/class/Alert";
import { Environment } from "src/app/shared/decorators/environment.decorators";
import { globalConst } from "src/app/shared/helpers/constants";
import { Helper } from "src/app/shared/helpers/helper";
import { UmovmeEnvironment } from "src/app/shared/models/umove-environment.model";
import { User } from "src/app/shared/models/user.model";
import { AuthService } from "src/app/shared/services/auth.service";
import Swal from "sweetalert2";
import { LoginService } from "../../login.service";
import { UmovmeEnvironmentService } from "./../../../umovme-environment/umovme-environment.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  @Environment("environmentName")
  environmentName;
  version = globalConst.version;
  loginForm: FormGroup;
  showPassword = false;
  subscription = new Subscription();
  logo = "";
  systemTitle = globalConst.systemTitle;
  umovmeEnvironments: UmovmeEnvironment[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private router: Router,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private umovmeEnvironmentService: UmovmeEnvironmentService
  ) {
    this.logo = Helper.getLogo();
  }

  ngOnInit() {
    if (window.location.href.indexOf("npcsolucoes") > 0) {
      Alert.info(
        ``,
        "O nosso portal mudou de endereço",
        `<p>A partir de agora, o acesso ao portal deve ser realizado através do novo endereço <br />
        <a href='https://portal-sabara.np3tecnologia.com.br/'>https://portal-sabara.np3tecnologia.com.br/</a><br /><br />
        Lembre-se de adicionar o novo endereço nos favoritos. Este endereço será descontinuado em 01/07/2023.</p>`
      ).then(() => {
        this.spinner.show();
        window.location.href = "https://portal-sabara.np3tecnologia.com.br/";
      });
    }

    if (this.authService.isLoggedIn()) {
      this.router.navigate([`${globalConst.router.home}`]);
    }

    this.loginForm = this.formBuilder.group({
      username: this.formBuilder.control("", [Validators.required]),
      password: this.formBuilder.control("", [Validators.required]),
      umovmeEnvironment: this.formBuilder.control(
        this.umovmeEnvironments.find((env) => env.default) || null, // Store object instead of id
        [Validators.required]
      ),
    });

    this.subscription.add(
      this.umovmeEnvironmentService.all().subscribe((res) => {
        this.umovmeEnvironments = res.data;
        this.loginForm.controls.umovmeEnvironment.setValue(
          this.umovmeEnvironments.find((env) => env.default)
        );
      })
    );
  }

  handleChangeVisibilityPassword() {
    this.showPassword = !this.showPassword;
  }

  handleLogin() {
    // this.fakeLogin();
    this.subscription.add(
      this.loginService.login({ ...this.loginForm }).subscribe(
        (data: User) => {
          this.authService.setUserLogged({
            ...data,
            environment: btoa(
              JSON.stringify({
                id: this.loginForm.value.umovmeEnvironment.id,
                name: this.loginForm.value.umovmeEnvironment.name,
              })
            ),
          });
          if (!this.authService.isTokenExpired()) {
            const userLogged = this.authService.getUserLogged();
            if (userLogged.firstAccess) {
              this.router.navigate([globalConst.router.home]);
              this.router.navigate([globalConst.router.changePassword], {
                queryParams: { id: userLogged.id },
              });
            } else {
              this.router.navigate([globalConst.router.home]);
            }
          }
        },
        (error) => {
          Alert.error(Alert.getMessage().errors.user.invalidLogin).then(() => {
            this.authService.logout();
          });
        }
      )
    );
  }

  getErrorMessage(e) {
    if (this.loginForm.controls[e].errors.required) {
      return globalConst.form.requiredField;
    }
  }

  showForgotPassword() {
    Swal.fire({
      title: '<p style="font-size: 16px;">Não conseguiu entrar?</p>',
      text: "Enviaremos uma nova senha para seu e-mail",
      input: "text",
      inputPlaceholder: "Informe seu usuário",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: false,
      confirmButtonText: "Enviar nova senha",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.loginService.forgetPassword(result.value).subscribe(
          (data: any) => {
            this.spinner.hide();
            Alert.success(
              `Uma nova senha foi enviada para o e-mail: ${data.emailSend}`,
              Alert.getMessage().success.resetPassword
            );
          },
          (error) => {
            this.spinner.hide();
            Alert.error(Alert.getMessage().errors.userNotFound);
          }
        );
      }
    });
  }
}
